import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import ImageTag from "../ImageTag/Index";
import Container from "../Container/Index";
import BreadCrumb from "../BreadCrumb/Index";
import { CircularProgress } from "@mui/material";
import Title from '../Title/Index'
import axios from "axios";
import { API_BASE_URL } from "../../Utils/useApi";

const ExhibitionDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [exhibition, setExhibition] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // In a real application, you would fetch this from your API
    // For now, we will use the API response directly
    const fetchExhibitionDetail = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/exhibition_details.php?slug=${slug}`
        );

        // Dummy data lookup - replace with actual API call
        setExhibition(response.data);
      } catch (error) {
        console.error("Error fetching exhibition:", error);
        setExhibition(null);
      } finally {
        setLoading(false);
      }
    };

    fetchExhibitionDetail();
  }, [slug]);



  if (loading) {
    return (
      <Container _parentClass={"p-100"}>
        <div className="h-full flex-center">
          <CircularProgress size={40} />
        </div>
      </Container>
    );
  }

  if (!exhibition) {
    return (
      <Container _parentClass={"p-100"}>
        <div className="text-center">
          <h2>Exhibition not found</h2>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate('/media/exhibitions')}
          >
            Back to Exhibitions
          </button>
        </div>
      </Container>
    );
  }

  return (
    <>
      <BreadCrumb
        customBreadCrum={true}
        firstName={"Media"}
        pageLink={"/media/exhibitions"}
        secondName={"Exhibitions"}
        thirdName={exhibition.exhibition_name}
      />

      <Container _parentClass={"p-100"}>
        <div className="col-lg-10 col-11 m-auto overflow-hidden">
          <div className="exhibition-gallery-section">
            <Title firstHeading={'Exhibitions'} secondHeading={exhibition.exhibition_name} _class={"mb-3"}
            // subTitle={exhibition.description}
            />
            <div className="flex-center gap-3 mb-5 flex-column">


              {exhibition.description.map((item, index) => (
                <p key={index} className="col-12 max-w-1000 mx-auto mb-0 mt-1 text-center">{item}</p>
              ))}
            </div>


            <div className="exhibition-lightgallery">
              <LightGallery
                onInit={() => { }}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
                className="exhibition-detail-gallery"
              >
                {exhibition.gallery_images.map((image, index) => (
                  <a
                    key={index}
                    href={image.largeImageUrl}      // fallback
                    data-src={image.largeImageUrl}  // ✅ tells LG to use large image
                    className="gallery-item"
                  >
                    <div className="gallery-image-wrapper">
                      <ImageTag
                        ImagePath={image.imageUrl}  // thumbnail
                        ImageAlt={image.news_paperName}
                        className="gallery-thumbnail col-12"
                      />
                    </div>
                  </a>
                ))}
              </LightGallery>

            </div>
          </div>
        </div>
      </Container >
    </>
  );
};

export default ExhibitionDetail;
